<div class="translation-ctn" *ngIf="!isAuthenticated || passwordReset ">
  <div></div>
  <div class="flex-row align-center language-options">
    <div class="flex-row align-center" (click)="onLanguageSelect($event)">
      <ion-thumbnail>
        <ion-img src="/assets/image/flags/{{currentLanguage |  lowercase}}.svg"></ion-img>
      </ion-thumbnail>
      <ion-icon name="chevron-down-outline"></ion-icon>
    </div>
  </div>
</div>
